
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Link } from 'react-router-dom';

interface DsgvoConsentCheckboxProps {
  id?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  required?: boolean;
  className?: string;
}

const DsgvoConsentCheckbox: React.FC<DsgvoConsentCheckboxProps> = ({
  id = 'privacy-consent',
  checked,
  onCheckedChange,
  required = true,
  className = ''
}) => {
  return (
    <div className={`flex items-start space-x-2 ${className}`}>
      <Checkbox 
        id={id}
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        required={required}
        className="mt-1 data-[state=checked]:bg-chrona-accent data-[state=checked]:border-chrona-accent"
      />
      <div className="space-y-1 leading-none">
        <label
          htmlFor={id}
          className="text-sm font-medium leading-none text-chrona-gray-300 peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          Ich akzeptiere die{' '}
          <Link to="/datenschutz" className="text-chrona-accent hover:text-chrona-accent-light underline">
            Datenschutzbestimmungen
          </Link>
          {' '}und{' '}
          <Link to="/agb" className="text-chrona-accent hover:text-chrona-accent-light underline">
            AGB
          </Link>
          {required && '*'}
        </label>
        <p className="text-xs text-chrona-gray-400">
          Wir verwenden deine Daten ausschließlich zur Bearbeitung deiner Anfrage 
          und gemäß unserer Datenschutzbestimmungen.
        </p>
      </div>
    </div>
  );
};

export default DsgvoConsentCheckbox;
